<mat-form-field class="app-datepicker" [floatLabel]="asFormsControl().floatingLabelNever && 'never'">
    <input
        matInput
        #datepickerInput
        readonly
        autocomplete="off"
        [matDatepicker]="datepicker"
        [min]="asFormsControl().minDate"
        [max]="asFormsControl().maxDate"
        [placeholder]="control.placeholder"
        (click)="openDatepicker(datepicker)"
        (dateChange)="changeValue($event)"
    >
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>

    <mat-datepicker
        [startAt]="asFormsControl().startDateAt"
        #datepicker
        [disabled]="control.disabled"
        (opened)="onTouched && onTouched()"
    ></mat-datepicker>
<a
    *ngIf="asFormsControl().resetable"
    href="javascript:void(0)"
    class="close-button fa fa-close"
    (click)="resetDatepicker()"
></a>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
